import {
  updateCurrentWorkoutExerciseIndexStartWorkoutAction
} from '../../../../start-workout/actions/update-current-workout-exercise-index'
import hasStartedStartWorkoutSelect from '../../../../start-workout/selectors/has-started'
import updateCurrentWorkoutExerciseAction from '../../../../workout-exercise/redux/actions/set-current'
import updateCurrentSetIndexWorkoutExerciseAction
  from '../../../../workout-exercise/redux/actions/update-current-set-index'
import getCircuitCurrentRoundIndexWorkoutSectionSelect from '../../selectors/get-circuit-current-round-index'
import { getCurrentRoundWorkoutSectionSelector } from '../../selectors/get-current-round'

function updateCurrentRoundIndexWorkoutExerciseAction (roundIndex) {
  return (dispatch, getState) => {
    const currentRoundIndex = getCircuitCurrentRoundIndexWorkoutSectionSelect(
      getState())
    if (roundIndex === currentRoundIndex) {
      return
    }

    const round = getCurrentRoundWorkoutSectionSelector(roundIndex)(getState())
    if (!round) {
      return
    }
    const roundSet = round[0]
    const setIndex = roundSet.setIndex

    if (hasStartedStartWorkoutSelect(getState())) {
      dispatch(updateCurrentWorkoutExerciseIndexStartWorkoutAction(roundSet.workoutExerciseOrder -
        1))
      dispatch(updateCurrentSetIndexWorkoutExerciseAction(setIndex))
      return
    }

    dispatch(updateCurrentWorkoutExerciseAction(roundSet.workoutExerciseId))
    dispatch(updateCurrentSetIndexWorkoutExerciseAction(setIndex))
  }
}

export { updateCurrentRoundIndexWorkoutExerciseAction }
